import { useResetRecoilState } from "recoil";
import { ActiveEmailAtom } from "../atoms/ActiveEmailAtom";
import { ActiveEmailListAtom } from "../atoms/ActiveEmailListAtom";
import { AllEmailsAtom } from "../atoms/AllEmailsAtom";
import { AllEmailListAtom } from "../atoms/AllEmailsListAtom";
import { billingAtom, newBillingAtom } from "../atoms/BillingAtom";
import { CampaignActionAtom } from "../atoms/CampaignActionAtom";
import {
  ActiveCampaignAtom,
  ContactCampaignStepsAtom,
  TempCampaignAtom,
} from "../atoms/CampaignAtom";
import { CampaignEmailAtom } from "../atoms/CampaignEmailAtom";
import { CampaingBuilderFormAtom } from "../atoms/CampaingBuilderFormAtom";
import { CharactersLenghtAtom } from "../atoms/CharactersLenghtAtom";
import {
  ContactFilterAtom,
  IsCheckedAllContactsAtom,
} from "../atoms/ContactFilterAtom";
import { ContactFiltersAtom } from "../atoms/ContactFiltersAtom";
import {
  ContactsAtom,
  ContactsTotalAtom,
  FilteredContactsAtom,
} from "../atoms/ContactsAtom";
import { ContactsPerPageAtom } from "../atoms/ContactsPerPageAtom";
import { DataFromCsvAtom } from "../atoms/DataFromCsvAtom";
import {
  DelayTimeAtom,
  DelayTimeIsOverAtom,
  DelayTimeToEndAtom,
} from "../atoms/DelayTimeAtom";
import { EmailLinksAtom } from "../atoms/EmailLinksAtom";
import { FontSizeAtom } from "../atoms/FontSizeAtom";
import { FullScreenAtom } from "../atoms/FullScreenAtom";
import { LabelAtom } from "../atoms/LabelAtom";
import { LinksAtom } from "../atoms/LinksAtom";
import { NewEmailAtom } from "../atoms/NewEmailAtom";
import { NewFormAtom } from "../atoms/NewFormAtom";
import { NodeIndexAtom } from "../atoms/NodeIndexAtom";
import { ContactNotesAtom, NoteCategoriesAtom } from "../atoms/NotesAtom";
import { PhoneAtom } from "../atoms/PhoneAtom";
import { PlayButtonAtom } from "../atoms/PlayButtonAtom";
import { RecipientAtom } from "../atoms/RecipientAtom";
import { CountedSavedSearchesAtom } from "../atoms/SavedSearches";
import { ScheduleDateAtom } from "../atoms/ScheduleDateAtom";
import { SelectedCampaignsAtom } from "../atoms/SelectedCampaigns";
import { SelectedContactsAtom } from "../atoms/SelectedContactsAtom";
import {
  SelectedTagsAtom,
  SelectedTagsBatchDeleteAtom,
} from "../atoms/SelectedTags";
import { TagsAtom } from "../atoms/TagsAtom";
import {
  CategoriesAtom,
  IsCheckedAllCategoriesAtom,
} from "../atoms/CategoriesAtom";
import { TestDriveBannerAtom } from "../atoms/TestDriveBannerAtom";
import upsellsAtom from "../atoms/UpsellsAtom";
import { InternalUserAtom, LoginUserAtom, UserAtom } from "../atoms/UserAtom";
import { UserEmailRestrictionsAtom } from "../atoms/UserEmailRestrictionsAtom";
import { WordsLengthAtom } from "../atoms/WordsLengthAtom";
import {
  CategoriesMoreActionsPopOverLoadingAtom,
  TagsMoreActionsPopOverLoadingAtom,
} from "../atoms/MoreActionsPopoverAtom";
import { ZoomAtom, ZoomAtomCampaignNotes } from "../atoms/ZoomAtom";

export function useResetAllRecoil() {
  const ActiveEmailAtomReset = useResetRecoilState(ActiveEmailAtom);
  const ActiveEmailListAtomReset = useResetRecoilState(ActiveEmailListAtom);
  const AllEmailsAtomReset = useResetRecoilState(AllEmailsAtom);
  const AllEmailListAtomReset = useResetRecoilState(AllEmailListAtom);
  const ActiveCampaignAtomReset = useResetRecoilState(ActiveCampaignAtom);
  const BillingAtomReset = useResetRecoilState(billingAtom);
  const CategoriesAtomReset = useResetRecoilState(CategoriesAtom);
  const CampaignActionAtomReset = useResetRecoilState(CampaignActionAtom);
  const CampaingBuilderFormAtomReset = useResetRecoilState(
    CampaingBuilderFormAtom
  );
  const CampaignEmailAtomReset = useResetRecoilState(CampaignEmailAtom);
  const CategoriesMoreActionsPopOverLoadingAtomReset = useResetRecoilState(
    CategoriesMoreActionsPopOverLoadingAtom
  );
  const CharactersLenghtAtomReset = useResetRecoilState(CharactersLenghtAtom);
  const ContactFilterAtomReset = useResetRecoilState(ContactFilterAtom);
  const ContactFiltersAtomReset = useResetRecoilState(ContactFiltersAtom);
  const ContactsTotalAtomReset = useResetRecoilState(ContactsTotalAtom);
  const ContactsPerPageAtomReset = useResetRecoilState(ContactsPerPageAtom);
  const ContactsAtomReset = useResetRecoilState(ContactsAtom);
  const ContactNotesAtomReset = useResetRecoilState(ContactNotesAtom);
  const ContactCampaignStepsAtomReset = useResetRecoilState(
    ContactCampaignStepsAtom
  );
  const CountedSavedSearchesAtomReset = useResetRecoilState(
    CountedSavedSearchesAtom
  );
  const DataFromCsvAtomReset = useResetRecoilState(DataFromCsvAtom);
  const DelayTimeAtomReset = useResetRecoilState(DelayTimeAtom);
  const DelayTimeToEndAtomReset = useResetRecoilState(DelayTimeToEndAtom);
  const DelayTimeIsOverAtomReset = useResetRecoilState(DelayTimeIsOverAtom);
  const EmailLinksAtomReset = useResetRecoilState(EmailLinksAtom);
  const FilteredContactsAtomReset = useResetRecoilState(FilteredContactsAtom);
  const FontSizeAtomReset = useResetRecoilState(FontSizeAtom);
  const FullScreenAtomReset = useResetRecoilState(FullScreenAtom);
  const IsCheckedAllContactsAtomReset = useResetRecoilState(
    IsCheckedAllContactsAtom
  );
  const IsCheckedAllCategoriesAtomReset = useResetRecoilState(
    IsCheckedAllCategoriesAtom
  );
  const LabelAtomReset = useResetRecoilState(LabelAtom);
  const LinksAtomReset = useResetRecoilState(LinksAtom);
  const NewBillingAtomReset = useResetRecoilState(newBillingAtom);
  const NewEmailAtomReset = useResetRecoilState(NewEmailAtom);
  const NewFormAtomReset = useResetRecoilState(NewFormAtom);
  const NodeIndexAtomReset = useResetRecoilState(NodeIndexAtom);
  const NoteCategoriesAtomReset = useResetRecoilState(NoteCategoriesAtom);
  const PlayButtonAtomReset = useResetRecoilState(PlayButtonAtom);
  const PhoneAtomReset = useResetRecoilState(PhoneAtom);
  const RecipientAtomReset = useResetRecoilState(RecipientAtom);
  const ScheduleDateAtomReset = useResetRecoilState(ScheduleDateAtom);
  const SelectedContactsAtomReset = useResetRecoilState(SelectedContactsAtom);
  const SelectedTagsAtomReset = useResetRecoilState(SelectedTagsAtom);
  const SelectedTagsBatchDeleteAtomReset = useResetRecoilState(
    SelectedTagsBatchDeleteAtom
  );
  const SelectedCampaignsAtomReset = useResetRecoilState(SelectedCampaignsAtom);
  const TagsAtomReset = useResetRecoilState(TagsAtom);
  const TagsMoreActionsPopOverLoadingAtomReset = useResetRecoilState(
    TagsMoreActionsPopOverLoadingAtom
  );
  const TempCampaignAtomReset = useResetRecoilState(TempCampaignAtom);
  const TestDriveBannerAtomReset = useResetRecoilState(TestDriveBannerAtom);
  const LoginUserAtomReset = useResetRecoilState(LoginUserAtom);
  const UserAtomReset = useResetRecoilState(UserAtom);
  const UserEmailRestrictionsAtomReset = useResetRecoilState(
    UserEmailRestrictionsAtom
  );
  const UpsellsAtomReset = useResetRecoilState(upsellsAtom);
  const WordsLengthAtomReset = useResetRecoilState(WordsLengthAtom);
  const ZoomAtomReset = useResetRecoilState(ZoomAtom);
  const ZoomAtomCampaignNotesReset = useResetRecoilState(ZoomAtomCampaignNotes);
  const InternalUserAtomReset = useResetRecoilState(InternalUserAtom);

  const reset = () => {
    ActiveEmailAtomReset();
    ActiveEmailListAtomReset();
    AllEmailsAtomReset();
    AllEmailListAtomReset();
    ActiveCampaignAtomReset();
    BillingAtomReset();
    CategoriesAtomReset();
    CampaignActionAtomReset();
    CampaingBuilderFormAtomReset();
    CampaignEmailAtomReset();
    CategoriesMoreActionsPopOverLoadingAtomReset();
    CharactersLenghtAtomReset();
    ContactFilterAtomReset();
    ContactFiltersAtomReset();
    ContactsTotalAtomReset();
    ContactsPerPageAtomReset();
    ContactsAtomReset();
    ContactNotesAtomReset();
    ContactCampaignStepsAtomReset();
    CountedSavedSearchesAtomReset();
    DataFromCsvAtomReset();
    DelayTimeAtomReset();
    DelayTimeToEndAtomReset();
    DelayTimeIsOverAtomReset();
    EmailLinksAtomReset();
    FilteredContactsAtomReset();
    FontSizeAtomReset();
    FullScreenAtomReset();
    IsCheckedAllContactsAtomReset();
    IsCheckedAllCategoriesAtomReset();
    LabelAtomReset();
    LinksAtomReset();
    NewBillingAtomReset();
    NewEmailAtomReset();
    NewFormAtomReset();
    NodeIndexAtomReset();
    NoteCategoriesAtomReset();
    PlayButtonAtomReset();
    PhoneAtomReset();
    RecipientAtomReset();
    ScheduleDateAtomReset();
    SelectedContactsAtomReset();
    SelectedTagsAtomReset();
    SelectedTagsBatchDeleteAtomReset();
    SelectedCampaignsAtomReset();
    TagsAtomReset();
    TagsMoreActionsPopOverLoadingAtomReset();
    TempCampaignAtomReset();
    TestDriveBannerAtomReset();
    LoginUserAtomReset();
    UserAtomReset();
    UserEmailRestrictionsAtomReset();
    UpsellsAtomReset();
    WordsLengthAtomReset();
    ZoomAtomReset();
    ZoomAtomCampaignNotesReset();
    InternalUserAtomReset();
  };

  return reset;
}
